import type { RaceSummaryShellProps } from '@/modules/admin/pages/components/RaceSummaryShell/RaceSummaryShell.types'

import { RaceSummary } from '@/components/@Shared/UserManagmentCharts/RaceSummary/RaceSummary'

import { useAdminStatsServiceAdminStatsControllerGetRaceStats } from '@/__generated__/queries'

export function RaceSummaryShell({
  company,
  onUpdateChartsData,
}: RaceSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useAdminStatsServiceAdminStatsControllerGetRaceStats({
      company,
    })

  return (
    <RaceSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
